import type { FetchError } from '@atlassian/jira-fetch';

export const getUserHasPermissionToLink = (error: FetchError | undefined): Boolean =>
	error?.statusCode !== 401;
